import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';

@Component({
  selector: 'app-resume',
  templateUrl: './resume.component.html',
  styleUrls: ['./resume.component.scss']
})
export class ResumeComponent implements OnInit {

  personalDetailsForm: FormGroup;
  qualifactionsForm: FormGroup;
  languages: FormGroup[];
  otherLanguages: FormGroup[];
  experienceForm: FormGroup;
  referenceForm: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.personalDetailsForm = this.fb.group({
      name: ['', [Validators.required]],
      surname: ['', [Validators.required]],
      knownAs: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      identity: ['', [Validators.required]],
      age: ['', [Validators.required]],
      telephone: ['', [Validators.required]],
      nationality: ['', [Validators.required]],
      ethnicity: ['', [Validators.required]],
      residentialAddress: ['', [Validators.required]],
      email: ['', [Validators.required]],
      maritalStatus: ['', [Validators.required]],
      dependants: ['', [Validators.required]],
      driversLicence: ['', [Validators.required]],
      ownTransport: ['', [Validators.required]],
      language: ['']
    });
    this.languages = [];
    this.otherLanguages = [];
    for (const lngStreing of ['English', 'afrikaans']) {
      this.languages.push(this.fb.group({
        languageName: [lngStreing],
        speak: [false ],
        read: [false ],
        write: [false ],
      }));
    }

    this.qualifactionsForm = this.fb.group({
      newSkill: [''],
      school: [this.fb.group({
        name: ['', [Validators.required]],
        grade: ['', [Validators.required]],
        year: ['', [Validators.required]],
      }), [Validators.required]],
      tertiary: [ this.fb.array(
        [
          this.fb.group({
            instituteName: ['', [Validators.required]],
            qualifactionName: ['', [Validators.required]],
            qualifactionType: ['', [Validators.required]],
            QualifactionYear: ['', [Validators.required]],
          })
        ]),
      ],
      skills: [ this.fb.array(
        [
        ])
      ]
    });

    this.referenceForm = this.fb.group({
      references: [this.fb.array([])]
    });
    
    this.experienceForm = this.fb.group({
      workExperience: [this.fb.array([])]
    });
  }
  addLanguage() {
    const language = this.personalDetailsForm.controls.language.value.trim();
    this.personalDetailsForm.controls.language.setValue('');
    if (language.length > 0) {
      this.otherLanguages.push(this.fb.group({
        languageName: [language],
        speak: [false ],
        read: [false ],
        write: [false ],
      }));
    }
  }
  addQualification() {

    for (const qual of this.qualifactionsForm.controls.tertiary.value.controls) {
      if (qual.invalid){
        return;
      }
    }
    this.qualifactionsForm.controls.tertiary.value.insert(
      this.qualifactionsForm.controls.tertiary.value.controls.length,
        this.fb.group({
          instituteName: ['', [Validators.required]],
          qualifactionName: ['', [Validators.required]],
          qualifactionType: ['', [Validators.required]],
          QualifactionYear: ['', [Validators.required]],
        })
      );
  }
  addExperience() {

    for (const expi of this.experienceForm.controls.workExperience.value.controls) {
      if (expi.invalid){
        return;
      }
    }
    this.experienceForm.controls.workExperience.value.insert(
      this.experienceForm.controls.workExperience.value.controls.length,
        this.fb.group({
          companyName: ['', [Validators.required]],
          companyType: ['', [Validators.required]],
          companyLocation: ['', [Validators.required]],
          positionHeld: ['', [Validators.required]],
          employedFrom: ['', [Validators.required]],
          employedTo: ['', [Validators.required]],
          reasonForLeaving: [''],
          newDuty: [''],
          currentEmployer: [false],
          duties: [this.fb.array([])]
        })
      );
  }
  addDuty(index: number) {
    if (index >= 0 && this.experienceForm.controls.workExperience.value.controls.length > index) {
      const newDuty = this.experienceForm.controls.workExperience.value.controls[index].controls.newDuty.value.trim();
      this.experienceForm.controls.workExperience.value.controls[index].controls.newDuty.setValue('');
      if (newDuty === ''){
        return;
      }
      this.experienceForm.controls.workExperience.value.controls[index].controls.duties.value.insert(
        this.experienceForm.controls.workExperience.value.controls[index].controls.duties.value.controls.length,
        this.fb.group({
          duty: [newDuty],
        })
      );
    }
  }
  addReference() {

    for (const expi of this.referenceForm.controls.references.value.controls) {
      if (expi.invalid){
        return;
      }
    }
    this.referenceForm.controls.references.value.insert(
      this.referenceForm.controls.references.value.controls.length,
        this.fb.group({
          companyName: ['', [Validators.required]],
          RefereeName: ['', [Validators.required]],
          RefereePosition: ['', [Validators.required]],
          telephoneNumber: ['', [Validators.required]],
        })
      );
  }
  removeLanguage(index: number) {
    if (index >= 0 && this.otherLanguages.length > index) {
      if (this.otherLanguages[index].controls.languageName.value.trim() === '' ) {
        this.otherLanguages.splice(index, 1);
      }
    }
  }
  removeQualification(index: number) {
    if (index >= 0 && this.qualifactionsForm.controls.tertiary.value.controls.length > index) {
      this.qualifactionsForm.controls.tertiary.value.removeAt(index);
    }
  }
  removeExperience(index: number) {
    if (index >= 0 && this.experienceForm.controls.workExperience.value.controls.length > index) {
      this.experienceForm.controls.workExperience.value.removeAt(index);
    }
  }
  removeReference(index: number) {
    if (index >= 0 && this.referenceForm.controls.references.value.controls.length > index) {
      this.referenceForm.controls.references.value.removeAt(index);
    }
  }
  addSkill() {
    const newSkill = this.qualifactionsForm.controls.newSkill.value.trim();
    if (newSkill === ''){
      return;
    }
    this.qualifactionsForm.controls.newSkill.setValue('');
    this.qualifactionsForm.controls.skills.value.insert(
      this.qualifactionsForm.controls.skills.value.controls.length,
        this.fb.group({
          skillDescription: [newSkill]
        })
      );
  }
  removeSkill(index: number) {
    if (index >= 0 && this.qualifactionsForm.controls.skills.value.controls.length > index) {
      if (this.qualifactionsForm.controls.skills.value.controls[index].controls.skillDescription.value.trim() === ''){
        this.qualifactionsForm.controls.skills.value.removeAt(index);
      }
    }
  }
  removeDuty(parentIndex: number, index: number) {
    if (parentIndex >= 0 && this.experienceForm.controls.workExperience.value.controls.length > parentIndex) {
      if (index >= 0 &&
        this.experienceForm.controls.workExperience.value.controls[parentIndex].controls.duties.value.controls.length > index) {
      if (this.experienceForm.controls.workExperience.value.controls[parentIndex]
        .controls.duties.value.controls[index].controls.duty.value.trim() === ''){
        this.experienceForm.controls.workExperience.value.controls[parentIndex].controls.duties.value.removeAt(index);
      }

      }
      const newDuty = this.experienceForm.controls.workExperience.value.controls[parentIndex].controls.newDuty.value.trim();
      if (newDuty === ''){
        return;
      }
      this.experienceForm.controls.workExperience.value.controls[index].controls.duties.value.insert(
        this.experienceForm.controls.workExperience.value.controls[index].controls.duties.value.controls.length,
        this.fb.group({
          duty: [newDuty],
        })
      );
    }
  }

  
  saveResume() {
    alert('This section of the system has not been linked to the database yet');
  }
}
